import https from "./https.js"
import { getFormData } from "@/utils/index.js"
/**
 * @param {*} method 方法
 * @param {*} url 路径
 * @param {*} data 传给后端的数据
 * @param {*} isFormData  是否需要转换为formData
 * @param {*} headers 需要传的头部数据
 * @param {*} isQuery 参数是否是query类型
 * @returns 
 */
function request(method,url,data,isFormData,headers,isQuery) {
  if(isFormData){
    data = getFormData(data)
  }
  if( method === 'get'){
    return https({
      method: method,
      url,
      params:data,
      headers:isFormData?{ 'Content-Type': 'multipart/form-data',...headers }:{'Content-Type': 'application/json',...headers}, //给接口添加请求}
    })
  }
  return https({
    method: method,
    url,
    data:data,
    headers:isFormData
    ?{ 'Content-Type': 'multipart/form-data',...headers }
    :{'Content-Type':isQuery?'application/x-www-form-urlencoded': 'application/json',...headers}, //给接口添加请求}
  })
}

export let Get = (url, data,isFormData, headers)=> {
  return request('get', url, data,isFormData, headers)
}
export let Post = (url, data,isFormData, headers,isQuery)=> {
  return request('post', url, data,isFormData, headers,isQuery)
}
export let Put = (url, data,isFormData, headers)=> {
  return request('put', url, data,isFormData, headers)
}
export let Delete = (url, data,isFormData, headers)=> {
  return request('delete', url, data,isFormData, headers)
}
